/** Max length of a normalized hex string including `#` (e.g. `#RRGGBB`). */
export const COLOR_FIELD_HEX_MAX_LENGTH = 7;

/**
 * Strips illegal characters, keeps a single leading `#`, caps at six hex digits
 * after `#` (seven characters total). Returns `""` when there is nothing to show.
 */
export function filterHexInput(raw: string): string {
  const only = raw.replace(/[^#0-9A-Fa-f]/gi, "");
  if (only.length === 0) {
    return "";
  }
  const firstHash = only.indexOf("#");
  const hexPart = (firstHash >= 0 ? only.slice(firstHash + 1) : only).replace(
    /#/g,
    "",
  );
  const digits = hexPart.slice(0, 6);
  if (firstHash === -1) {
    return digits.length > 0 ? `#${digits}` : "";
  }
  return `#${digits}`;
}

/**
 * Returns normalized `#RRGGBB` (uppercase) or `null` if the string is not a
 * complete valid hex color.
 */
export function normalizeHex(input: string): string | null {
  const filtered = filterHexInput(input);
  if (filtered.length !== COLOR_FIELD_HEX_MAX_LENGTH) {
    return null;
  }
  const body = filtered.slice(1);
  if (!/^[0-9A-Fa-f]{6}$/.test(body)) {
    return null;
  }
  return `#${body.toUpperCase()}`;
}

export function isValidHex(input: string): boolean {
  return normalizeHex(input) !== null;
}
